// src/shared/components/ui/tabs.tsx

import type { ButtonHTMLAttributes, HTMLAttributes } from 'react'

import { cn } from '@/shared/utils/cn'

interface TabButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean
}

export function TabsList({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'inline-flex gap-1 rounded-md border border-[var(--panel-border)] bg-[var(--panel-subtle)] p-1',
        className,
      )}
      {...props}
    />
  )
}

export function TabButton({ active, className, ...props }: TabButtonProps) {
  return (
    <button
      className={cn(
        'h-7 rounded-sm px-2.5 text-xs font-medium transition',
        active
          ? 'bg-[var(--panel)] text-[var(--color-text)] shadow-sm'
          : 'text-[var(--color-text-soft)] hover:text-[var(--color-text)] hover:bg-[var(--panel)]/60',
        className,
      )}
      type="button"
      {...props}
    />
  )
}
